import { EmployeeRole } from "./role-type";

export interface EmployeeDTO {
  uuid?: string;
  mail: string;
  role: EmployeeRole;
  isOrganizationAdmin: boolean;
  orgUUID: string;
}

export const EMPLOYEE_SORT = {
  byEmail: (employee: EmployeeDTO): string => employee.mail,
  byPermissions: (employee: EmployeeDTO): number => {
    switch (true) {
      case employee.isOrganizationAdmin:
        return 2;
      case employee.role === EmployeeRole.ADMIN:
        return 1;
      case employee.role === EmployeeRole.VIEWER:
        return 0;
      default: return -1;
    }
  },
};
